import React, { useState } from 'react';
import { Modal } from '../../../design-system';
import { useAdminStore } from '../../../store/adminStore';
import styles from './ApproveDialog.module.css';

interface ApproveDialogProps {
  onApprove: () => void;
}

export const ApproveDialog: React.FC<ApproveDialogProps> = ({ onApprove }) => {
  const {
    approveDialogOpen,
    approvalNotes,
    setApprovalNotes,
    closeApproveDialog,
    isLoading,
  } = useAdminStore();

  const [localNotes, setLocalNotes] = useState(approvalNotes);

  const handleApprove = async () => {
    setApprovalNotes(localNotes);
    onApprove();
  };

  return (
    <Modal
      isOpen={approveDialogOpen}
      onClose={closeApproveDialog}
      size="md"
      closeOnEsc={!isLoading}
      closeOnBackdropClick={!isLoading}
    >
      <Modal.Header>
        <h2 className={styles.title}>Approve Application?</h2>
      </Modal.Header>

      <Modal.Body>
        <div className={styles.content}>
          <p className={styles.message}>
            This action will:
          </p>
          <ul className={styles.actionList}>
            <li>Create a user account for the applicant</li>
            <li>Send an approval email with login credentials</li>
            <li>Grant access to VIN Pulse OS</li>
          </ul>

          <div className={styles.formGroup}>
            <label htmlFor="approval-notes" className={styles.label}>
              Internal Notes (Optional)
            </label>
            <textarea
              id="approval-notes"
              value={localNotes}
              onChange={(e) => setLocalNotes(e.target.value)}
              placeholder="Add any internal notes about this approval..."
              className={styles.textarea}
              rows={3}
              disabled={isLoading}
            />
            <p className={styles.helperText}>
              These notes are for internal use only and won't be shared with the applicant.
            </p>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className={styles.actions}>
          <button
            className={styles.cancelButton}
            onClick={closeApproveDialog}
            disabled={isLoading}
            type="button"
          >
            Cancel
          </button>
          <button
            className={styles.confirmButton}
            onClick={handleApprove}
            disabled={isLoading}
            type="button"
          >
            {isLoading ? 'Approving...' : '✓ Approve Application'}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
